import ComponentGroupComponentsList from '~/components/ComponentGroups/ComponentGroupDetails/tabs/ComponentGroupComponents/ComponentGroupComponentsList';

export const ComponentGroupComponentsTab: React.FC = () => {
  return <ComponentGroupComponentsList />;
};
